// extracted by mini-css-extract-plugin
export default {"info":"N8y0dIdpnx","h-rule":"IunhHkBkrI","hRule":"IunhHkBkrI","logo":"vrIZ0iGTL6","further-resources":"VSrEz41Qg+","furtherResources":"VSrEz41Qg+"};
    if(module.hot) {
      // 1648554153859
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  